module.exports = __webpack_public_path__ + "img/game_person.8fced7b6.png";